<template>
    <div v-loading="loading" class="alarmClass">
      <div>

        <el-tabs v-model="activeName" @tab-click="handleClick" :before-leave="tabsBefore">
          <el-tab-pane label="健康数据" name="first" lazy>
            <healthInfo ref="healthInfoRef" :model="model" :row="row"></healthInfo>
          </el-tab-pane>
          <el-tab-pane label="健康评估" name="second" lazy>
            <gradeHealth :model="model" :row="row"></gradeHealth>
           </el-tab-pane>
          <el-tab-pane label="健康随访记录" name="third" lazy>
            <healthVisitRecord :model="model" :row="row"></healthVisitRecord>
          </el-tab-pane>

          <el-tab-pane label="健康体检记录" name="four" lazy>
            <healthTest :model="model" :row="row"></healthTest>
          </el-tab-pane>
          <el-tab-pane
            label="健康就诊记录"
            name="five"
          >
          <healthTreatRecord :model="model" :row="row"></healthTreatRecord>
          </el-tab-pane>
          <el-tab-pane
            label="健康预警"
            name="six"
          >
          <healthWarning :model="model" :row="row"></healthWarning>
          </el-tab-pane>

        </el-tabs>

      </div>
    </div>
  </template>
  <script>
  import { getProjectList } from '@/api/crmedical/project/project';
  import { getDictionary } from '@/api/common.js';
  import healthInfo from './healthInfo';
  import gradeHealth from './gradeHealth';
  import healthVisitRecord from './healthVisitRecord';
  import healthTest from './healthTest';
  import healthTreatRecord from './healthTreatRecord';
  import healthWarning from './healthWarning';
  import { removeStore, getStore } from '@/util/store';
  import { setStore } from '@/util/store';

  export default {
    components: {healthInfo,gradeHealth,healthVisitRecord,healthTest,healthTreatRecord,healthWarning},
    props: {
      row: {
        default: {},
      },
      nursinghomeId: {},
      nursinghomeName: {},
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        activeFlag: true,
        projectList: [],
        activeName: 'first',
        form: {
          nursinghomeId: '',
          name: '',
          // birthday: '123',
          idNumber: '',
        },
        formRules: {

        },
        matetialList: [],
      };
    },
    created() {
      this.initData();
      console.log(this.model, 'modelmodelmodel');
    },
    mounted() {},
    watch: {},
    methods: {

      initData() {
        this.$refs.healthInfoRef.initData()
      },

      handleClick() {
        if (this.activeName === 'first') {
          this.$refs.healthInfoRef.initData();
        }
        if (this.activeName === 'second') {
          this.$refs.FamilyInfoRef.initData();
        }
        if (this.activeName === 'third') {
          this.$refs.HealthInfoRef.initData();
          // this.activeName = 'fourth'
        }
        if (this.activeName === 'fourth') {
          this.$refs.MedicalTestInfoRef.initData();
          // this.activeName = 'five'
        }
        if (this.activeName === 'five') {
          this.$refs.CateringBedsInfoRef.initData();
        }
        console.log(this.activeName);
      },

    },
  };
  </script>
  <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
